import { useContext } from 'react';
import { BrazeContext } from './BrazeContext';

export function useBraze() {
  return useContext(BrazeContext);
}
